import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";
import roles from "@/config/lists/roles";

function mapBackendRolesToDisplay(backendRoles, allRoles) {
  return backendRoles
    .map((roleFromApi) => allRoles.find((r) => r.enumName === roleFromApi.name))
    .filter(Boolean); // remove unmatched
}

const actions = () => ({
  async getUserData(payload) {
    const response = await api.get(`/api/user/data/${payload.id}`);
    const displayRoles = mapBackendRolesToDisplay(response.data.roles, roles);

    this.user = {
      ...response.data,
      roles: displayRoles, // Replace roles with the transformed version
    };
    this.authenticated = true;
    return this.user;
  },

  async createUser(payload) {
    await api.post("/api/user/admin/create", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The user has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/user/admin/overview");
  },

  async editUser(payload) {
    this.user = {};
    await api.post(`/api/user/admin/edit/${payload.id}`, payload);
    if (payload.image) {
      const formData = new FormData();
      formData.append("file", payload.image);

      const result = await api.post(
        `/api/files/${payload.id}/admin/upload/user_photo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.user = result.data;
      return this.user;
    } else {
      const result = await api.delete(
        `/api/files/${payload.id}/admin/remove/user_photo`,
        {}
      );
      this.user = result.data;
    }
    this.user = this.getUserData(payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    // router.push("/dashboard");
  },

  async activateUser(payload) {
    try {
      const response = await api.post(
        `/api/user/admin/active/${payload.id}`,
        payload
      );
      if (response.status == 200) {
        const globalStore = useGlobalStore();
        globalStore.showSnackbar({
          show: true,
          text: "User has been activated.",
          timeout: 3000,
          type: "success",
          position: "top",
        });
      }
    } catch (error) {
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Failed to activate user. Server error.",
        timeout: 3000,
        type: "error",
        position: "top",
      });
    }
    this.resetAction();
  },

  async deactivateUser(payload) {
    try {
      const response = await api.post(
        `/api/user/admin/active/${payload.id}`,
        payload
      );
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "User has been deactivated.",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    } catch (error) {
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "Failed to activate user. Server error.",
        timeout: 3000,
        type: "error",
        position: "top",
      });
    }
    this.resetAction();
  },

  async getAdminUsersOverview(payload) {
    const res = await api.get("/api/user/admin/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getUser(payload) {
    const res = await api.get(`/api/user/admin/${payload.id}`);
    return res.data;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/user/admin/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      regDates: [],
    };
  },
});

export default actions;
